import { createSelector } from 'reselect';

const getHovered = ({ hovered }) => hovered;

export default createSelector(
  [getHovered],
  hovered => hovered
);
